import React, { Component } from "react";
import RootItemUpload from "container/upload/RootItemUpload";
import GatewayCheckpoint from "container/common/GatewayCheckpoint";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";
import { getEssentialUrl } from "lib/urlQueryParser";

class UploadItemPage extends Component {
  render() {
    return (
      <AppUpdateCheckpoint>
        <GatewayCheckpoint
          type={"replace"}
          url={getEssentialUrl({ type: "opening" })()}
        >
          <RootItemUpload />
        </GatewayCheckpoint>
      </AppUpdateCheckpoint>
    );
  }
}

export default UploadItemPage;
